import { isEmptyObject } from 'jquery';
import * as _ from 'lodash';
import { isUndefined } from 'lodash';
import { all, create } from 'mathjs/lib/esm/number';
import * as React from 'react';
import { format, parse } from 'date-fns';
import { ControlValueDispatcher } from '../libs/helpers/Dispatcher';
import {
  getKeys,
  getLastRowForSum,
  I18NString,
  tr,
} from '../libs/helpers/Utils';
import { Dictionary } from '../types/Dictionary';
import { createControl, IControlError } from './Controls';
import Form from './Form';
import { ISectionSchema } from './Section';
import { adapterToFns } from '../libs/helpers/MomentToFnsAdapter';
import { detailObject } from '../libs/controls/ButtonSet/interfaces';

interface Props {
  section: ISectionSchema;
  dispatcher: ControlValueDispatcher;
  disableNumber: boolean;
  countToSend: number;
  readonly: boolean;
  values: any;
  api: any;
  extRules: any;
  status: number;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>;
  allVisited: boolean;
  firstErrorId: string;
  cities: Array<any>;
  tags: Array<any>;
  projects: Array<any>;
  company: Array<any>;
  userRole: string;
  changedControls?: Array<string>;
  controlMode?: any;
  sections?: any;
  urlParams?: { [key: string]: string };
  countries?: any;
  flows?: any;
  allSections?: unknown;
  rowSection?: unknown;
  dynamicOptions?: Record<string, Array<unknown>>;
  formActions: {
    // Обновление формы
    actionRefreshForm: () => void;
    // Скролл до поля, с условным обновлением формы
    actionScrollToField: (controlId: string, refresh: boolean) => void;
    actionDetailNotify: (detail: detailObject) => void;
  };
  //Дополнительные котроллы, которые приходят в библиотеку с пропсов, специфичные для какого либо проекта
  remoteControls?: {
    [key: string]: (...args: any) => any;
  };
}
//
class Content extends React.Component<Props, Record<string, unknown>> {
  private tr: (message: I18NString) => string = tr;

  shouldComponentUpdate() {
    return true;
  }

  // eslint-disable-next-line react/sort-comp
  protected emitBlur(id, value, valid, error) {
    if (typeof value === 'object') {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.dispatcher.onBlur(id, value, valid, error);
    } else {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.dispatcher.onBlur(id, `${value}`, valid, error);
    }
  }

  public getConditionResult(condition, a, b) {
    switch (condition) {
      case 'Equal': {
        return a === b;
      }
      case 'NotEqual': {
        return a !== b;
      }
      default: {
        return false;
      }
    }
  }

  public mathResult(src, target, option, value) {
    if (!src) return 0;
    const source = src?.length ? src : [src];
    if (!source.length) return 0;
    switch (option) {
      case 'SumOfDates': {
        let results = 0;
        for (let k = 0; k < source?.length || 0; k++) {
          const { beginDate, finishDate } = source[k];
          if (beginDate && finishDate) {
            const begin = parse(beginDate, 'dd.MM.yyyy', new Date());
            const finish = parse(finishDate, 'dd.MM.yyyy', new Date());
            results += adapterToFns(begin, finish, value);
          }
        }
        return results;
      }
      default:
        return 0;
    }
  }

  render() {
    const {
      section,
      sections,
      allSections,
      rowSection,
      dispatcher,
      api,
      values,
      tags,
      cities,
      projects,
      company,
      changedControls,
      controlMode,
      countries,
      flows,
      readonly,
      // TODO: Убруать потом динамические опшины
      dynamicOptions,
      urlParams,
      extRules: { FORMS_URL, HOST, URL_PREFIX },
    } = this.props;
    if (!isEmptyObject(section)) {
      const controls: Array<React.ReactElement<any>> = [];

      // create hash table and push field array who need autofill
      const needFillFields = [];

      const hashControls =
        sections !== undefined &&
        sections.reduce(
          (acc: any, item: any) => ({
            ...acc,
            ...item.controls.reduce((acc2, item2) => {
              if (item2.fill_rule && !readonly) {
                needFillFields.push(item2);
              }

              return {
                ...acc2,
                [item2.id]: item2,
              };
            }, {}),
          }),
          {},
        );

      const getNameFromField = (
        _hashControls: any,
        path: string,
        type: string,
        defaultName: string,
        action?: 'sum' | 'replace',
        withValue?: number | string,
      ) => {
        let result;
        // Небольшой костыль, так как диапазон дат может быть как массивом, так и объектом
        // Заменяем все [0] если значение не нашлось на просто обращение к свойству
        const valueFromPath =
          _.get(_hashControls, path, null) ??
          _.get(_hashControls, path.replace('[0]', ''), null);
        if (!valueFromPath || typeof valueFromPath === 'object') {
          return defaultName;
        }

        // define the type and parse
        switch (type) {
          case 'year': {
            result = +format(new Date(valueFromPath), 'yyyy');
            break;
          }
          case 'string': {
            result = `${valueFromPath}`;
            break;
          }
          case 'number': {
            result = +valueFromPath;
            break;
          }
          default: {
            result = valueFromPath;
            break;
          }
        }

        // work action with result
        if (action && withValue) {
          switch (action) {
            case 'sum': {
              result += withValue;
              break;
            }
            case 'replace': {
              // @ts-ignore
              result = withValue.replaceAll('value', result);
              break;
            }
            default: {
              break;
            }
          }
        }

        return result;
      };

      const getValueFromField = (
        _hashControls: any,
        from: any,
        result: any,
      ): number => {
        const sourceData = {};
        // eslint-disable-next-line guard-for-in
        for (const index in from) {
          const currentItem = from[index];
          const valuesWhichNeed = currentItem.grid
            ? _hashControls?.[currentItem.grid]
            : _hashControls?.[currentItem.field];

          if (valuesWhichNeed?.value) {
            if (typeof valuesWhichNeed.value === 'string') {
              // Если значение просто строка значит попросили не Grid компонент, сразу передаем его и парсим
              const value = valuesWhichNeed?.value;
              sourceData[index] = value ? +value : undefined;
            } else {
              // Если значение объект, то сначала выясним какой тип данных должны получить
              // column: string = складываем все строки; 0: number = берем конкретную строку
              // eslint-disable-next-line no-lonely-if
              if (typeof currentItem.type === 'number') {
                const value =
                  valuesWhichNeed.value?.[currentItem.type]?.[
                    currentItem.field
                  ];
                sourceData[index] = value ? +value : undefined;
              } else if (currentItem.type === 'column') {
                sourceData[index] = valuesWhichNeed.value?.reduce(
                  (acc, item) => acc + +(item?.[currentItem.field] ?? 0),
                  0,
                );
              }
            }
          } else {
            sourceData[index] = undefined;
          }
        }

        const math = create(all);
        try {
          result = `${math.evaluate(result, sourceData)}`;
        } catch (error) {
          result = undefined;
        }

        return result;
      };

      // change field if is need
      for (const item of needFillFields) {
        // create hash object
        if (item?.fill_rule) {
          const option = item?.fill_rule.option;
          const value = item?.fill_rule.value;
          const controlTarget = hashControls[item?.fill_rule.controlTargetId];
          const controlSource = hashControls[item?.fill_rule.controlSourceId];

          if (
            this.getConditionResult(option, !!controlTarget?.value, !!value)
          ) {
            // С приведением типов могут сравниваться null и undefined
            if (item.value !== controlSource.value) {
              // console.log('Значение этого элемента', item.id);
              // console.log(item.value);
              // console.log('Меняем значением этого элемента', controlSource.id);
              // console.log(controlSource.value);

              this.emitBlur(item.id, controlSource.value, true, undefined);
            }
            continue;
          }

          // Вычисляемое значение поля по параметру fill_rule
          const funcValue = this.mathResult(
            controlSource?.value,
            controlTarget?.value,
            option,
            value,
          );
          if (item.value !== funcValue && funcValue) {
            this.emitBlur(item.id, funcValue, true, undefined);
          }
        }
      }

      // TODO: replace with test optional chaining ->  (const ctrl of section?.controls ?? [])
      // eslint-disable-next-line no-restricted-syntax
      for (const ctrl of section?.controls) {
        if (this.props.readonly) {
          ctrl.disabled = this.props.readonly;
        }
        // Если у GRID нашлось поле fixedValue изменяем schema
        if (
          (ctrl.type === 'Grid' || ctrl.type === 'GridEditable') &&
          ctrl.fixedValue
        ) {
          ctrl.extra = {
            ...ctrl.extra,
            add_row_enabled: false,
            del_row_enabled: false,
          };
          if (!readonly && !ctrl.value) {
            this.emitBlur(ctrl.id, ctrl.fixedValue, true, undefined);
          }
        }

        // Если у GRID нашлось поле fixedValueWithCalculate изменяем schema
        for (const ctrl of section?.controls) {
          if (this.props.readonly) {
            // ctrl.disabled = this.props.readonly;
          }
          // Если у GRID нашлось поле fixedValueWithCalculate изменяем schema
          if (
            (ctrl.type === 'Grid' || ctrl.type === 'GridEditable') &&
            ctrl.fixedValueWithCalculate
          ) {
            ctrl.extra = {
              ...ctrl.extra,
              add_row_enabled: false,
              del_row_enabled: false,
            };
            if (!readonly && !ctrl.value) {
              this.emitBlur(
                ctrl.id,
                ctrl.fixedValueWithCalculate,
                true,
                undefined,
              );
            }
          }
        }
        // Если у Grid в поле "blockedIfEmpty": "*" пусто, то блокируем таблицу
        if (ctrl.type === 'Grid' && ctrl.blockedIfEmpty) {
          const isHaveValue = !!this.props.dispatcher.pullValue(
            ctrl.blockedIfEmpty.id,
          );
          let errorAlreadyHave;

          if (!isHaveValue) {
            ctrl.extra = {
              ...ctrl.extra,
              add_row_enabled: false,
              del_row_enabled: false,
            };
            ctrl.disabled = true;

            // Показываем ошибку у таблицы (если такой еще нет в списке)
            // TODO вынести бы в отдельную функцию checkIfErrorAlreadyHas
            if (this.props.errors[ctrl.id]) {
              if (
                typeof this.props.errors[ctrl.id].message === 'object' &&
                this.props.errors[ctrl.id].message.length > 0
              ) {
                // eslint-disable-next-line array-callback-return,consistent-return
                errorAlreadyHave = !!this.props.errors[ctrl.id].message.find(
                  (item) => {
                    if (item.message === ctrl.blockedIfEmpty.errorMessage) {
                      return true;
                    }
                  },
                );
              } else if (
                typeof this.props.errors[ctrl.id].message === 'string'
              ) {
                if (
                  this.props.errors[ctrl.id].message ===
                  ctrl.blockedIfEmpty.errorMessage
                ) {
                  errorAlreadyHave = true;
                }
              }
            }

            if (!errorAlreadyHave) {
              this.props.dispatcher.setError(
                ctrl.id,
                ctrl.value,
                {
                  message: ctrl.blockedIfEmpty.errorMessage,
                },
                true,
              );
            }
          }
        }

        // Если GRID и у него нашлось свойство nameFromField
        // Имя колонки меняем здесь
        if (
          (ctrl.type === 'Grid' || ctrl.type === 'GridEditable') &&
          ctrl.columns
        ) {
          // TODO: replace for on Object{keys, values, entries}
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const index in ctrl.columns) {
            const column = ctrl.columns[index];
            if (column?.nameFromField) {
              ctrl.columns[index].name =
                getNameFromField(
                  hashControls,
                  column.nameFromField.from,
                  column?.nameFromField.type,
                  column?.nameFromField.defaultName,
                  column?.nameFromField?.action,
                  column?.nameFromField?.withValue,
                ) ?? ctrl.columns[index].name;
            }
          }
        } else if (ctrl?.valueFromField) {
          const newValue = getValueFromField(
            hashControls,
            ctrl.valueFromField.from,
            ctrl.valueFromField.result,
          );

          if (!readonly && newValue && ctrl.value !== newValue) {
            this.emitBlur(ctrl.id, newValue, true, undefined);
            // this.props.dispatcher.onVisit(ctrl.id);
          }
        }

        ctrl.disableNumber = this.props.disableNumber;

        // if (!isUndefined(ALLOWED_FIELDS[userRole]) && !isUndefined(ALLOWED_FIELDS[userRole][status])) {
        //     ctrl.disabled = ALLOWED_FIELDS[userRole][status].indexOf(ctrl.contentNumb) < 0;
        // } else {
        //     if (this.props.readonly) {
        //         ctrl.disabled = true
        //     }
        // }

        if (ctrl.type === 'DropBox') {
          ctrl.countries = countries;
          ctrl.flows = flows;
        }

        // TODO: Mutation Type after condition
        if (ctrl?.widget?.selectType && ctrl?.widget?.dynamicType) {
          ctrl.type = dynamicOptions?.[ctrl.widget.selectType]?.length
            ? 'DropBox'
            : ctrl?.widget?.dynamicType;
        }

        // i18n control
        if (ctrl?.extra?.i18n) {
          const i18nControl = section.controls.find(
            (item) =>
              ctrl.extra.i18n.includes(item.id) &&
              (item.type === 'i18n' || item.type === 'i18n_complex'),
          );
          if (i18nControl) {
            ctrl.extra.i18nControls = i18nControl;
          }
        }
        if (ctrl.type === 'i18n' || ctrl.type === 'i18n_complex') {
          continue;
        }

        // Priority control enable from control_mode props
        if (
          controlMode &&
          Object.keys(controlMode)?.length &&
          controlMode?.[ctrl.id]
        ) {
          if (controlMode[ctrl.id]?.isHidden) {
            continue;
          }

          ctrl.disabled = false;
        }

        if (
          !isUndefined(changedControls) &&
          changedControls.indexOf(ctrl.id) > -1
        )
          ctrl.changed = true;

        const people: any = [];
        if (ctrl?.extra?.init === 'getPeople') {
          const contactsCEO =
            this.props.dispatcher.pullValue('contactsCEO') ?? [];
          const contactsStaff =
            this.props.dispatcher.pullValue('contactsStaff') ?? [];

          const allContacts = [
            ...contactsCEO.filter((item) => !item.isDeleted),
            ...contactsStaff.filter((item) => !item.isDeleted),
          ];

          // Сверка на наличие
          const currentSelects = allContacts.reduce(
            (acc, item) => [...acc, item.key],
            [],
          );
          const currentValues = this.props.dispatcher.pullValue(ctrl.id);
          const newValues = [];
          if (currentValues) {
            currentValues.forEach((item) => {
              if (currentSelects.includes(item)) {
                newValues.push(item);
              }
            });
          }

          // Собираем option для селекта
          allContacts.forEach((contact) => {
            people.push({
              name: {
                ru: `${
                  (contact.contactsCEOPosition || contact.staffPosition) ?? ''
                } ${(contact.contactsCEOPhone || contact.staffPhone) ?? ''} ${
                  (contact.contactsCEOEmail || contact.staffEmail) ?? ''
                }`,
                en: '',
              },
              id: contact.key,
              key: contact.key,
              type_id: null,
              parent: null,
              parent_id: null,
            });
          });

          if (currentValues && _.difference(currentValues, newValues).length) {
            this.props.dispatcher.onBlur(
              ctrl.id,
              newValues,
              undefined,
              undefined,
              {
                tags,
                cities,
                people,
                projects,
                company,
                ext_rules: {
                  FORMS_URL,
                  HOST,
                  URL_PREFIX,
                },
              },
            );
          }
        }

        const element = createControl(
          // Сам контрол из metajson
          // { ...ctrl, disabled: readonly || ctrl.disabled },
          ctrl,
          // Общие Api методы для взаимодействия с сетью (загрузка формы, отправление значения контрола итд)
          // -Иногда бывает что в url приходит {request_id} итд. Так вот все эти параметры находятся тут в options
          api,
          // TODO
          dispatcher,
          // Ошибки к этому полю
          this.props.errors,
          // Значение поля
          values,
          // TODO
          this.props.visited,
          // TODO
          this.props.allVisited,
          // Дополнительные данные для поля (динамические опшены, конфигурация, formActions итд)
          {
            tags,
            cities,
            people,
            projects,
            company,
            ext_rules: {
              FORMS_URL,
              HOST,
              URL_PREFIX,
            },
            formActions: {
              actionRefreshForm: this.props.formActions.actionRefreshForm,
              actionScrollToField: this.props.formActions.actionScrollToField,
            },
            rowSection,
          },
          // TODO Еще одно место для доп данных. Переместить выше
          {
            userRole: this.props.userRole,
            formStatus: this.props.status,
          },
          allSections,
          // TODO Еще какой то пропс для динамических пропсов. Надо объединить все в одном месте
          dynamicOptions,
          undefined,
          this.props.remoteControls &&
            Object.keys(this.props.remoteControls).reduce((acc, item) => {
              return {
                ...acc,
                [item.toUpperCase()]: this.props.remoteControls[item],
              };
            }, {}),
        );
        const key = `Content.${section.id}.${ctrl.id}`;
        if (!ctrl.isPortal) {
          controls.push(element && React.cloneElement(element, { key }));
        }

        let bottom_line_classname = 'line';
        if (
          !isUndefined(ctrl.extra) &&
          !isUndefined(ctrl.extra['bottom-line-margin'])
        ) {
          switch (ctrl.extra['bottom-line-margin']) {
            case 'default': {
              bottom_line_classname = 'line';
              break;
            }
            case 'large': {
              bottom_line_classname = 'line large';
              break;
            }
            case 'medium': {
              bottom_line_classname = 'line medium';
              break;
            }
            case 'small': {
              bottom_line_classname = 'line small';
              break;
            }
            case 'min': {
              bottom_line_classname = 'line min';
              break;
            }
            default:
              break;
          }
        }

        if (urlParams) {
          ctrl.urlParams = urlParams || {};
        }

        if ((isUndefined(ctrl.visible) || ctrl.visible) && !ctrl.isPortal) {
          controls.push(
            <div key={`${key}.line`} className={bottom_line_classname} />,
          );
        }
        // TODO: need test
        // else if (ctrl.visible) {
        // 	controls.push(<div key={`${key}.line`} className={bottom_line_classname} />);
        // }
      }

      return (
        <div className="reportbox-content">
          <h4>{section.titleInForm ? this.tr(section.titleInForm) : this.tr(section.title)}</h4>
          <div className="line" />
          {section.id === 'DetailedEstimateConsolidated' && (
            <button
              onClick={(e) => {
                e.preventDefault();

                const idx = this.props.sections.findIndex(
                  (section) => section.id === 'DetailedEstimateConsolidated',
                );
                const { controls } = this.props.sections[idx];

                for (let i = controls.length - 1; i >= 0; i--) {
                  const updatedValue = [...controls[i].fixedValueWithCalculate];
                  for (let j = 0; j < updatedValue.length; j++) {
                    if (updatedValue[j].groups !== null) {
                      const { dependsOn } = updatedValue[j];
                      if (dependsOn && hashControls[dependsOn].value?.length) {
                        const lastRow = getLastRowForSum(
                          hashControls[dependsOn].value,
                          hashControls[dependsOn],
                        );

                        if (lastRow) {
                          for (
                            let b = 0;
                            b < hashControls[dependsOn].value[0].groups.length;
                            b++
                          ) {
                            const group = `group_${b}`;

                            updatedValue[j].groups[b] = {
                              key: `stage-${b}`,
                              stage: lastRow[group],
                            };

                            if (
                              dependsOn ===
                              'DeveloperServicesWorksImplementation_Grant'
                            ) {
                              const lastRow2 = getLastRowForSum(
                                hashControls
                                  .DeveloperServicesWorksDevelopment_Grant
                                  .value,
                                hashControls.DeveloperServicesWorksDevelopment_Grant,
                              );

                              if (lastRow[group] && lastRow2[group]) {
                                updatedValue[j].groups[b].stage +=
                                  lastRow2[group];
                              } else if (!lastRow[group] && lastRow2[group]) {
                                updatedValue[j].groups[b].stage =
                                  lastRow2[group];
                              }
                            }

                            if (
                              dependsOn ===
                              'DeveloperServicesWorksImplementation_NonBudget'
                            ) {
                              const lastRow2 = getLastRowForSum(
                                hashControls
                                  .DeveloperServicesWorksDevelopment_NonBudget
                                  .value,
                                hashControls.DeveloperServicesWorksDevelopment_NonBudget,
                              );

                              if (lastRow[group] && lastRow2[group]) {
                                updatedValue[j].groups[b].stage +=
                                  lastRow2[group];
                              } else if (!lastRow[group] && lastRow2[group]) {
                                updatedValue[j].groups[b].stage =
                                  lastRow2[group];
                              }
                            }
                          }
                          updatedValue[j].totalStagePrice =
                            lastRow.totalStagePrice;
                        }
                      }

                      if (i === 0) {
                        const keys = getKeys(hashControls);
                        const grant: any = keys.filter((key) =>
                          key.toString().includes('_Grant'),
                        );
                        const nonBudget: any = keys.filter((key) =>
                          key.toString().includes('_NonBudget'),
                        );

                        const grantGroups = [];
                        for (let group = 0; group < grant.length; group++) {
                          if (
                            !grant[group].startsWith(
                              'OverheadExpenditureRentTravel',
                            )
                          ) {
                            const lastRow = getLastRowForSum(
                              hashControls[grant[group]].value,
                              hashControls[grant[group]],
                            );

                            if (lastRow) {
                              for (
                                let b = 0;
                                b <
                                hashControls[grant[group]].value[0].groups
                                  .length;
                                b++
                              ) {
                                const group = `group_${b}`;
                                if (grantGroups?.[b]?.stage && lastRow[group]) {
                                  grantGroups[b].stage += lastRow[group];
                                } else if (
                                  !grantGroups?.[b]?.stage &&
                                  lastRow[group]
                                ) {
                                  grantGroups.push({
                                    key: `stage-${b}`,
                                    stage: lastRow[group],
                                  });
                                }
                              }
                            }
                          }
                        }

                        const nonBudgetGroups = [];
                        for (let group = 0; group < nonBudget.length; group++) {
                          if (
                            !nonBudget[group].startsWith(
                              'OverheadExpenditureRentTravel',
                            )
                          ) {
                            const lastRow = getLastRowForSum(
                              hashControls[nonBudget[group]].value,
                              hashControls[nonBudget[group]],
                            );

                            if (lastRow) {
                              for (
                                let b = 0;
                                b <
                                hashControls[grant[group]].value[0].groups
                                  .length;
                                b++
                              ) {
                                const group = `group_${b}`;
                                if (
                                  nonBudgetGroups?.[b]?.stage &&
                                  lastRow[group]
                                ) {
                                  nonBudgetGroups[b].stage += lastRow[group];
                                } else if (
                                  !nonBudgetGroups?.[b]?.stage &&
                                  lastRow[group]
                                ) {
                                  nonBudgetGroups.push({
                                    key: `stage-${b}`,
                                    stage: lastRow[group],
                                  });
                                }
                              }
                            }
                          }
                        }

                        if (
                          updatedValue[j].sourceFinance ===
                          'Общий бюджет проекта, руб.'
                        ) {
                          let sumGroups = [];

                          if (grantGroups.length > nonBudgetGroups.length) {
                            sumGroups = grantGroups;
                          } else {
                            sumGroups = nonBudgetGroups;
                          }

                          for (
                            let group = 0;
                            group < sumGroups.length;
                            group++
                          ) {
                            if (grantGroups.length > nonBudgetGroups.length) {
                              sumGroups[group].stage +=
                                nonBudgetGroups?.[group]?.stage ?? 0;
                            } else {
                              sumGroups[group].stage +=
                                grantGroups?.[group]?.stage ?? 0;
                            }
                          }

                          updatedValue[j].groups = sumGroups;
                          updatedValue[j].totalStagePrice = sumGroups.reduce(
                            (prev, val) => prev + val.stage,
                            0,
                          );
                        } else if (
                          updatedValue[j].sourceFinance ===
                          'Средства гранта, руб'
                        ) {
                          updatedValue[j].groups = grantGroups;
                          updatedValue[j].totalStagePrice = grantGroups.reduce(
                            (prev, val) => prev + val.stage,
                            0,
                          );
                        } else if (
                          updatedValue[j].sourceFinance ===
                          'Внебюджетные средства, руб'
                        ) {
                          updatedValue[j].groups = nonBudgetGroups;
                          updatedValue[j].totalStagePrice =
                            nonBudgetGroups.reduce(
                              (prev, val) => prev + val.stage,
                              0,
                            );
                        } else if (
                          updatedValue[j].sourceFinance ===
                          'Доля внебюджетного финансирования в общем бюджете'
                        ) {
                          const sumGroups = updatedValue.find(
                            (val) =>
                              val.sourceFinance ===
                              'Общий бюджет проекта, руб.',
                          );
                          const divideGroups = JSON.parse(
                            JSON.stringify(sumGroups.groups),
                          );

                          for (
                            let group = 0;
                            group < divideGroups.length;
                            group++
                          ) {
                            if (
                              grantGroups.length > nonBudgetGroups.length &&
                              nonBudgetGroups?.[group]?.stage
                            ) {
                              divideGroups[group].stage = `${Math.floor(
                                (nonBudgetGroups[group].stage /
                                  divideGroups[group].stage) *
                                  100,
                              )}%`;
                            } else {
                              divideGroups[group].stage = `${0}%`;
                            }
                          }

                          const groupsWithoutPercentage = divideGroups.reduce(
                            (prev, val) => ({
                              stage:
                                prev.stage +
                                Number(val.stage.replace(/%\s?/g, '')),
                              countNotEmpty: Number(
                                val.stage.replace(/%\s?/g, ''),
                              )
                                ? prev.countNotEmpty + 1
                                : prev.countNotEmpty,
                            }),
                            { stage: 0, countNotEmpty: 0 },
                          );

                          updatedValue[j].groups = divideGroups;
                          updatedValue[j].totalStagePrice =
                            groupsWithoutPercentage.stage &&
                            groupsWithoutPercentage.countNotEmpty
                              ? `${Math.floor(
                                  groupsWithoutPercentage.stage /
                                    groupsWithoutPercentage.countNotEmpty,
                                )}%`
                              : '0%';
                        }
                      }
                    }
                  }
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  const newArray = updatedValue.map(
                    ({ dependsOn, ...keepAttrs }) => keepAttrs,
                  );
                  this.emitBlur(controls[i].id, newArray, true, undefined);
                }
              }}
            >
              Рассчитать
            </button>
          )}
          <Form>{controls}</Form>
        </div>
      );
    }

    return <div />;
  }
}

export default Content;
